import type { CurrencyRates } from "./currency-rates";

/** One reference-rate request per page, reused by every picker and subsequent selection. */
export function currencyRatesLoader(
  fetchRates: () => Promise<CurrencyRates | null>,
  now: () => number = Date.now,
) {
  let cached: CurrencyRates | null = null;
  let refreshedAt = 0;
  let pending: Promise<CurrencyRates | null> | undefined;
  return (): Promise<CurrencyRates | null> => {
    if (cached && now() - refreshedAt < 6 * 60 * 60 * 1000) return Promise.resolve(cached);
    if (pending) return pending;
    pending = fetchRates()
      .then((rates) => {
        if (rates) {
          cached = rates;
          refreshedAt = now();
        }
        return rates ?? cached;
      })
      .catch(() => cached)
      .finally(() => {
        pending = undefined;
      });
    return pending;
  };
}
